module.exports = __webpack_public_path__ + "static/media/restaurant_red.ab1d153b.png";